import { render, staticRenderFns } from "./contractRule.vue?vue&type=template&id=2ca5e209&scoped=true&"
import script from "./contractRule.vue?vue&type=script&lang=js&"
export * from "./contractRule.vue?vue&type=script&lang=js&"
import style0 from "./contractRule.vue?vue&type=style&index=0&id=2ca5e209&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5e209",
  null
  
)

export default component.exports